import { Input, InputProps } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Shake } from "reshake";
import { AirportSuggestion } from "../AirportSuggestion/AirportSuggestion";
import { Airport } from "@/models/airport";
import { t } from "i18next";

export interface AirportInputProps extends InputProps {
  type: "origin" | "destination";
  onSubmitGuess: (guess: {
    airport_guess: string;
    type: "origin" | "destination";
  }) => void;
  airports: Airport[];
  zIndex?: number;
  value: string;
  status: "success" | "error" | "not_set";
  guessDistance: number;
}

const animationDuration = 1000;

export const AirportInput = ({
  type,
  onSubmitGuess,
  airports,
  zIndex,
  value,
  status,
  guessDistance,
  ...props
}: AirportInputProps) => {
  const [shake, setShake] = useState(false);
  const [triggerKey, setTriggerKey] = useState(0);
  const [suggestionVisible, setSuggestionVisible] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setShake(status === "error");
    if (status === "error") {
      setTriggerKey(triggerKey + 1);
      setTimeout(() => {
        setShake(false);
      }, animationDuration);
    }
  }, [status, value, guessDistance]);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <>
      <Shake
        h={shake ? 10 : 0}
        v={0}
        r={0}
        dur={animationDuration}
        int={1.7}
        max={10}
        fixed={true}
        fixedStop={false}
        freez={false}
        style={{ height: "100%", zIndex: zIndex }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setSuggestionVisible(false);
            onSubmitGuess({ airport_guess: currentValue, type });
          }}
          style={{ height: "100%" }}
        >
          <Input
            placeholder={
              type === "origin"
                ? t("game.controls.origin")
                : t("game.controls.destination")
            }
            _selection={{
              color: "black",
              backgroundColor: "blue.200",
            }}
            bg={status === "success" ? "green.600" : "white"}
            disabled={status === "success"}
            _disabled={{
              opacity: 1,
            }}
            flex={1}
            maxWidth="250px"
            height="100%"
            minHeight="50px"
            fontSize={{ base: "2xl" }}
            textAlign="center"
            pointerEvents="auto"
            zIndex={zIndex}
            {...props}
            value={currentValue}
            onChange={(e) => {
              e.target.value = e.target.value.toUpperCase();
              setCurrentValue(e.target.value);
              setSuggestionVisible(true);
            }}
            onFocus={(e) => {
              e.target.select();
              setSuggestionVisible(true);
            }}
            onBlur={() => {
              setTimeout(() => {
                setSuggestionVisible(false);
              }, 300);
            }}
          />
          <AirportSuggestion
            airports={airports}
            term={currentValue}
            visible={suggestionVisible}
            onSelect={(airport) => {
              onSubmitGuess({ airport_guess: airport.iata, type });
            }}
            position={type === "origin" ? "top" : "bottom"}
          />
        </form>
      </Shake>
    </>
  );
};
